import Slider from '../../../javascripts/globals/slider';
import GallerySlider from './GallerySlider';
import BasicSlider from './BasicSlider';
import { MEDIA_QUERIES } from '../../../javascripts/constants';

const mql = window.matchMedia(MEDIA_QUERIES.m);

let componentStore = [];

function onMediaQueryChange(mq) {
  componentStore.forEach(
    (component) => component.deconstructor && component.deconstructor()
  );
  componentStore = [];

  document.querySelectorAll('.slider').forEach(($slider) => {
    const config = {
      showDots: $slider.getAttribute('data-dots') === 'true',
      showCount: $slider.getAttribute('data-count') === 'true',
      showPagination: $slider.getAttribute('data-pagination') === 'true',
      scrollContainerClass: '.slider__slides-wrap',
      itemsContainerClass: '.slider__slides',
      itemClass: '.slider__slide',
      focusableItemsClass: '.slider__slide .figure',
      itemsToScroll: 1,
      itemsVisible: 1,
      resizeVerticalImages: true,
    };

    if (config.showPagination) {
      componentStore.push(new GallerySlider($slider, mq, config));
    } else {
      componentStore.push(new BasicSlider($slider, mq, config));
    }
  });
}

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
